module.exports = "/packs/media/images/savings-growth-d3c4a09df81f53b06944319db5ad4f76.jpeg";